import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import React from 'react';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  editingRequest: boolean;
  loading: boolean;
}

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const { open, onClose, onConfirm, editingRequest, loading } = props;

  const handleConfirm = async () => {
    void onConfirm();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmación</DialogTitle>
      <DialogContent>
        <DialogContent>
          {loading ? (
            <CenteredCircularProgress type="dialog" />
          ) : (
            <>
              <Typography>
                {editingRequest
                  ? '¿Estás seguro de querer editar la operación de confirming?'
                  : '¿Estás seguro de querer crear la operación de confirming?'}
              </Typography>
            </>
          )}
        </DialogContent>
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={onClose} disabled={loading}>
          Cancelar
        </CustomButton>
        <CustomButton
          color="success"
          onClick={handleConfirm}
          disabled={loading}
        >
          Confirmar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
